import React, { FunctionComponent, lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';

// layouts
import LayoutDefault from './layouts/LayoutDefault';
import { Container, Spinner } from 'react-bootstrap';

// views
// import Home from './views/Home';
// import ThankYou from './views/ThankYou';
// import NftExplorer from './views/NftExplorer';
const Home = lazy(() => import('./views/Home'));
const ThankYou = lazy(() => import('./views/ThankYou'));
const NftExplorer = lazy(() => import('./views/NftExplorer'));
const UserManagement = lazy(() => import('./views/UserManagement'));
const Disclosures = lazy(() => import('./views/Disclosures'));
const AccountFAQ = lazy(() => import('./views/AccountFAQ'));
const GeneralFAQ = lazy(() => import('./views/GeneralFAQ'));
const ContactUs = lazy(() => import('./views/ContactUs'));
const About = lazy(() => import('./views/About'));

interface MainProps {}

const Main: FunctionComponent<MainProps> = () => {
  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="google-site-verification"
          content="bSPqvaFKATKmNtH92dgLhpJjtoXIoKbfkS-j9-fHtlI"
        />
        <link rel="icon" href="images/favicon.png" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#000000" />
        <title>Opencash | Invest with a purpose</title>
        <meta
          name="description"
          content="Our mission is to make investing fun and rewarding. With Opencash, you can invest in a SIPC-insured brokerage account."
        />
        <meta
          name="keywords"
          content="commission free trading, commission free options, commission free crypto, free crypto transfer, p2p, borrow against crypto, New, Crypto, Stock, Commission-free, options"
        />
      </Helmet>
      <Suspense
        fallback={
          <Container id="spinnerContainer">
            <Spinner id="spinnerLoading" animation={'border'} />
          </Container>
        }>
        <Routes>
          <Route element={<LayoutDefault />}>
            <Route path="/" element={<Home />} />
            <Route path="/thankyou" element={<ThankYou />} />
            <Route path="/nftexplorer" element={<NftExplorer />} />
            <Route path="userMangement" element={<UserManagement />} />
            <Route path="/disclosures" element={<Disclosures />} />
            <Route path="/account-faq" element={<AccountFAQ />} />
            <Route path="/general-faq" element={<GeneralFAQ />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/about" element={<About />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </Suspense>
    </HelmetProvider>
  );
};

export default Main;
